// Flags
import usFlag from '../images/us.png';
import esFlag from '../images/es.png';

const SUPPORTED_LOCALES = {
    en: 'English',
    es: 'Spanish',
};

const LOCALE_FLAGS = {
    en: usFlag,
    es: esFlag,
};

export default SUPPORTED_LOCALES;

export { LOCALE_FLAGS };



/** WEBPACK FOOTER **
 ** ./src/constants/supported-locales.js
 **/